<script lang="ts">
    import { Col ,Row } from "sveltestrap";
    import { GridColumn, GridColumnMessage } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    import data from "../../../Data/ComponentData/Ui-kits/Grid/Grid.json"
</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={GridColumn} CardBodyprops="grid-showcase">
      <div slot="contentbody">
        <p>{@html GridColumnMessage}</p>
        <Row>
          <Col md="1" class="text-center">
            <span>col-md-1</span>
          </Col>
          {#each data.GridColumndata as gridItem}
            <div class="{gridItem.size} text-center">
                <span>{gridItem.size}</span>
            </div>
          {/each}
        </Row>
      </div>
    </Card>
</Col>